export default {
  easyLanguage: 'Gemakkelijke taal',
  videoDoesNotYetExist: 'Video bestaat nog niet'
}



// WEBPACK FOOTER //
// ./src/i18n/common/nl.js